import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deduction-details-form',
  templateUrl: './deduction-details-form.component.html',
  styleUrls: ['./deduction-details-form.component.css']
})
export class DeductionDetailsFormComponent implements OnInit {

  title="Add Deduction Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/deduction-details/deduction-details-form/deduction-details-form.component.ts